function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.00878906,
  width: 51.7648,
  height: 55,
  rx: 15,
  fill: "white",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.5518 34.0983C35.3436 34.0983 38.4174 30.7835 38.4174 26.6944C38.4174 22.6054 35.3436 19.2906 31.5518 19.2906C29.5122 19.2906 27.6798 20.2487 26.4206 21.7753C26.3844 21.8369 26.344 21.8966 26.2994 21.954L25.996 22.344C25.9711 22.3808 25.9384 22.4117 25.9142 22.449L20.3911 29.5473C19.8495 30.2434 18.8871 30.3342 18.2417 29.7501C17.5962 29.166 17.512 28.1283 18.0536 27.4322L23.3346 20.6451C22.2153 19.7911 20.8501 19.2906 19.3749 19.2906C15.5831 19.2906 12.5093 22.6054 12.5093 26.6944C12.5093 30.7835 15.5831 34.0983 19.3749 34.0983C21.4146 34.0983 23.247 33.1402 24.5062 31.6136C24.5424 31.552 24.5828 31.4923 24.6274 31.4349L24.9309 31.0449C24.9558 31.0081 24.9883 30.9772 25.0125 30.9399L30.5357 23.8416C31.0774 23.1455 32.0396 23.0547 32.6851 23.6388C33.3306 24.2229 33.4148 25.2606 32.8732 25.9567L27.5923 32.7439C28.7115 33.5978 30.0767 34.0983 31.5518 34.0983ZM25.4634 35.1363C27.1431 36.547 29.2572 37.3889 31.5518 37.3889C37.0288 37.3889 41.4687 32.6009 41.4687 26.6944C41.4687 20.7881 37.0288 16 31.5518 16C29.2563 16 27.1433 16.8418 25.4635 18.2525C23.7836 16.8419 21.6695 16 19.3749 16C13.8979 16 9.45801 20.7881 9.45801 26.6944C9.45801 32.6009 13.8979 37.3889 19.3749 37.3889C21.6704 37.3889 23.7836 36.547 25.4634 35.1363Z",
  fill: "white"
});

function SvgTotalBal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 55,
    viewBox: "0 0 52 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBal);
export default __webpack_public_path__ + "static/media/totalBal.7d2c3fd4.svg";
export { ForwardRef as ReactComponent };